
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft, Mail } from 'lucide-react';

const ReferralSubmission = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-6">
          <Button
            variant="outline"
            onClick={() => navigate('/dashboard')}
            className="mb-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Button>
        </div>

        <Card className="max-w-2xl mx-auto">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Mail className="h-5 w-5" />
              Email-Only Referrals
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-muted-foreground">
              CareKonnect now uses an email-only referral system. To submit a referral:
            </p>
            <div className="space-y-2 text-left">
              <p>1. Browse listings in the search results</p>
              <p>2. Click "Submit Referral" on any available listing</p>
              <p>3. Select support areas needed (no PHI/PII)</p>
              <p>4. Your email client will open with a pre-filled referral</p>
            </div>
            <Button onClick={() => navigate('/browse')}>
              Browse Listings
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ReferralSubmission;
